import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="footer-social">
        <a
          href="https://instagram.com/erikhoffmanphotos"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          className="footer-icon"
        >
          <i className="fab fa-instagram" />
        </a>
        <a
          href="mailto:erik@erikhoffmanphotos.com"
          aria-label="Email"
          className="footer-icon"
        >
          <i className="fas fa-envelope" />
        </a>
      </div>
      <p className="footer-copy">
        &copy; {year} Erik Hoffman Photos &mdash; Baltimore, MD
      </p>
    </footer>
  );
}

export default Footer;
